export default "__VITE_ASSET__QRNcWaj5__"